import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppCustomerUserRoles from "@/components/roles/appCustomerUserRoles/AppCustomerUserRoles";

const AppCustomerUserRolesPage = () => {
  const { appId, customerId, userId } = useParams();
  const [userEmail, setUserEmail] = useState<string>("");

  const handleUserLoaded = (email: string) => {
    setUserEmail(email);
  };

  return (
    <>
      <AppCustomerUserRoles
        ApplicationId={Number(appId)}
        CustomerId={Number(customerId)}
        UserId={Number(userId)}
        ShowOnlyNewAppUserRolePanel={false}
        onUserLoaded={handleUserLoaded}
        breadcrumbTitle="Application | Customer | User | Roles"
        breadcrumbSubtitle={
          userEmail ? (
            <>
              Manage roles for user <strong>{userEmail}</strong>
            </>
          ) : (
            "Manage roles for this user"
          )
        }
        backPath={`/applications/${appId}/customers/${customerId}/users`}
      />
    </>
  );
};

export default AppCustomerUserRolesPage;
